export enum TrialChannel {
  Stripe = 1,
  Jicoo = 2,
}
